import { render } from "./FieldFailures.vue?vue&type=template&id=3151e67d&ts=true"
import script from "./FieldFailures.vue?vue&type=script&lang=ts"
export * from "./FieldFailures.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__